import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "checkbox", "counter", "submitBtn", "btnCount", "preview",
    "razon", "primeraFecha", "primeraEntrega", "segundaFecha", "segundaEntrega",
    "filterForm"
  ]

  toggleAll(event) {
    const checked = event.target.checked
    this.checkboxTargets.forEach(cb => cb.checked = checked)
    this.updateCounter()
  }

  updateCounter() {
    const count = this.checkboxTargets.filter(cb => cb.checked).length
    if (this.hasCounterTarget) {
      this.counterTarget.textContent = count > 0 ? `${count} seleccionado${count !== 1 ? 's' : ''}` : ''
    }
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = count === 0
      this.btnCountTarget.textContent = count
    }
  }

  checkboxTargetConnected() {
    this.updateCounter()
  }

  checkboxTargetDisconnected() {
    this.updateCounter()
  }

  filterByDate(event) {
    if (event) {
      const checkbox = event.target
      const label = this.filterFormTarget.querySelector(`label[for="${checkbox.id}"]`)
      if (label) {
        if (checkbox.checked) {
          label.classList.remove('btn-outline-secondary')
          label.classList.add('btn-success', 'text-white')
        } else {
          label.classList.remove('btn-success', 'text-white')
          label.classList.add('btn-outline-secondary')
        }
      }
    }
    this._navigatePatientList()
  }

  clearFilter() {
    this.filterFormTarget.querySelectorAll('input[type="checkbox"]').forEach(cb => {
      cb.checked = false
      const label = this.filterFormTarget.querySelector(`label[for="${cb.id}"]`)
      if (label) {
        label.classList.remove('btn-success', 'text-white')
        label.classList.add('btn-outline-secondary')
      }
    })
    this._navigatePatientList()
  }

  _navigatePatientList() {
    const params = new URLSearchParams()
    this.filterFormTarget.querySelectorAll('input[name="selected_dates[]"]:checked').forEach(cb => {
      params.append('selected_dates[]', cb.value)
    })
    const baseUrl = this.filterFormTarget.action.split('?')[0]
    const frame = document.getElementById('patient_list')
    if (frame) frame.src = params.toString() ? `${baseUrl}?${params}` : baseUrl
  }

  updatePreview() {
    const razon = this.razonTarget.value || "[razón]"
    const primeraFecha = this.primeraFechaTarget.value || "[primera fecha]"
    const primeraEntrega = this.primeraEntregaTarget.value || "[primera entrega]"
    const segundaFecha = this.segundaFechaTarget.value || "[segunda fecha]"
    const segundaEntrega = this.segundaEntregaTarget.value || "[segunda entrega]"

    this.previewTarget.innerHTML =
      `Hola [nombre]!\n\n` +
      `Te informamos que debido a <strong>${this.escape(razon)}</strong>, la entrega de las bandejas se realizará según el siguiente esquema:\n\n` +
      `<strong>${this.escape(primeraFecha)}</strong>: se entregarán bandejas de ${this.escape(primeraEntrega)}\n` +
      `<strong>${this.escape(segundaFecha)}</strong>: se entregarán bandejas de ${this.escape(segundaEntrega)}\n\n` +
      `En esta oportunidad la cancelación del servicio se realizará con 72 hs. de anticipación.\n\n` +
      `Por favor confirmar a este número de teléfono, o por mail a cs@cookingservice.com.ar.\n\n` +
      `Muchas gracias\n<em>Equipo Cooking Service</em>`
  }

  escape(str) {
    return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
  }
}
